import { ModalActionButton, ModalActions, ModalContent, useModalTitle, withModal, } from '@topconagriculture/modal';
import { withBaseProps } from '@topconagriculture/react-components';
import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { ProfilingForms } from '../../config';
import { CompanyForm } from '../CompanyForm';
const CompanyModal = (props) => {
    const { t, onSubmitHandler, onCompanyUpdate, closeModal, company, countries, isLoading, disabled, modalParams, tenantSettings, showBillingPeriod, } = props;
    const translationKey = company ? 'modal_title_edit' : 'modal_title_create';
    useModalTitle(t(`profiling:company_settings:${translationKey}`));
    return (React.createElement("div", null,
        React.createElement(ModalContent, null,
            React.createElement(CompanyForm, { onCompanyUpdate: onCompanyUpdate, company: company, isLoading: isLoading, countries: countries, tenantSettings: tenantSettings, showBillingPeriod: showBillingPeriod, ...modalParams })),
        React.createElement(ModalActions, { closeModal: closeModal },
            React.createElement(ModalActionButton, { disabled: disabled, testId: 'save-company', isLoading: isLoading, action: onSubmitHandler, btnLabel: t('common:save') }))));
};
export default compose(withModal, withBaseProps({ translations: ['profiling', 'common'] }), withHandlers({
    onSubmitHandler: ({ submit }) => () => {
        submit(ProfilingForms.editCompany);
    },
}))(CompanyModal);
//# sourceMappingURL=CompanyModal.js.map